import React from "react";
export const ExchangeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M13.9865 9.69451C14.3414 8.44082 14.2938 7.10733 13.8504 5.88213C13.407 4.65693 12.5902 3.60183 11.5151 2.86566C10.44 2.12948 9.16099 1.74938 7.85836 1.77895C6.55572 1.80852 5.29524 2.24627 4.25468 3.03047C3.21413 3.81467 2.446 4.90574 2.05865 6.14981C1.6713 7.39387 1.68427 8.72814 2.09573 9.96444C2.50718 11.2007 3.29636 12.2767 4.35196 13.0405C5.40756 13.8043 6.67632 14.2175 7.97928 14.2218'
        stroke='#7D7D7D'
        strokeWidth='1.04795'
        strokeLinecap='round'
      />
      <path
        d='M14.668 12.0322H10.668L12.2684 11.1113'
        stroke='#7D7D7D'
        strokeWidth='0.977778'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.668 13.7781H14.668L13.3346 14.6669'
        stroke='#7D7D7D'
        strokeWidth='0.977778'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.64896 12L7.64396 11.505C6.37397 11.41 5.41898 10.7 5.33898 9.56002L5.33398 9.49002H6.36897L6.37897 9.54502C6.47397 10.08 6.83397 10.51 7.64396 10.595V8.41003L7.43896 8.36503C6.15898 8.07004 5.48398 7.49004 5.48398 6.47505V6.47005C5.48398 5.36006 6.37897 4.61507 7.64396 4.52007V4H8.20896V4.52007C9.44395 4.61507 10.3189 5.34006 10.3989 6.43005L10.4039 6.51005H9.36395L9.35895 6.46505C9.28895 5.88506 8.85395 5.51006 8.20896 5.43006V7.52004L8.44896 7.57504C9.77394 7.88004 10.4839 8.42503 10.4839 9.49002V9.49502C10.4839 10.72 9.48395 11.42 8.20896 11.505L8.21396 12H7.64896ZM6.54397 6.41005C6.54397 6.87005 6.83897 7.20004 7.64396 7.39004V5.43006C6.92397 5.52006 6.54397 5.94506 6.54397 6.40005V6.41005ZM8.21896 8.54503L8.20896 8.54003V10.605C9.07395 10.535 9.42395 10.115 9.42395 9.58002V9.57502C9.42395 9.07003 9.15895 8.76503 8.21896 8.54503Z'
        fill='#7D7D7D'
      />
      <path d='M7.57422 4H8.53421V11.9999H7.57422V4Z' fill='#7D7D7D' />
    </svg>
  );
};

export const DropDownIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
      <path
        d='M6.78396 8.43773L4.52662 5.95466C4.35629 5.7673 4.48923 5.4668 4.74244 5.4668H9.25711C9.51032 5.4668 9.64326 5.7673 9.47293 5.95466L7.21559 8.43773C7.09987 8.56503 6.89968 8.56503 6.78396 8.43773Z'
        fill='#7D7D7D'
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M6.5 6.5L17.5 17.5'
        stroke='#121212'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.5 17.5L17.5 6.5'
        stroke='#121212'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
